import './FileDetail.scss';

export { default } from './FileDetail';
